import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.864 3.55762C19.2782 3.55762 19.614 3.8934 19.614 4.30762V8.55026C19.614 8.96447 19.2782 9.30026 18.864 9.30026H14.6213C14.2071 9.30026 13.8713 8.96447 13.8713 8.55026C13.8713 8.13604 14.2071 7.80026 14.6213 7.80026H16.9817C14.1363 5.55718 9.9987 5.74825 7.37348 8.37348C4.54217 11.2048 4.54217 15.7952 7.37348 18.6265C10.2048 21.4578 14.7952 21.4578 17.6265 18.6265C19.5234 16.7297 20.1504 14.0428 19.5039 11.6219C19.397 11.2217 19.6348 10.8106 20.035 10.7038C20.4352 10.5969 20.8462 10.8347 20.9531 11.2349C21.7321 14.1518 20.978 17.3964 18.6872 19.6872C15.2701 23.1043 9.7299 23.1043 6.31282 19.6872C2.89573 16.2701 2.89573 10.7299 6.31282 7.31282C9.54483 4.0808 14.6762 3.90576 18.114 6.78768V4.30762C18.114 3.8934 18.4497 3.55762 18.864 3.55762Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }